import type { EntryMeta } from '~/types'
import Gallery from '~/components/gallery/Gallery'
import type { MediaPath } from '~/generated/media'

const cover = 'portfolio/transition-cover.jpg' satisfies MediaPath
const eiffel = 'projects/eiffel_composite_web.png' satisfies MediaPath
const skyline = 'portfolio/170812_141204.png' satisfies MediaPath
const figure = 'portfolio/merkel50x50red_reduced.png' satisfies MediaPath
const collage = 'portfolio/download.png' satisfies MediaPath

export const meta: EntryMeta = {
	slug: 'transition',
	name: 'Transition',
	excerpt: 'Photographs rebuilt from thousands of photographs',
	tags: ['generative', 'photography'],
	cover,
	featured: true,
	order: 45,
}

export default function Transition() {
	return (
		<>
			<h2 className="font-bold text-xl mt-0">Overview</h2>
			<p>
				Photo-mosaics: a single image reconstructed tile by tile from a corpus of smaller frames,
				each placed by best color-and-luminance match. Up close it dissolves into its source
				library; at distance the original scene resolves.
			</p>
			<h2 className="font-bold text-xl">Plates</h2>
			<p>
				A riverfront skyline at dusk and a denser composite of Paris built from travel frames, plus
				figure and grid studies that push the tiles toward pure pattern. The full-resolution Eiffel
				plate runs to tens of thousands of tiles — linked at full size.
			</p>
			<Gallery
				cols={2}
				items={[
					{
						src: cover,
						alt: 'Transition — riverfront mosaic',
					},
					{
						src: eiffel,
						alt: 'Paris composite mosaic',
					},
					{ src: skyline, alt: 'Skyline study' },
					{ src: figure, alt: 'Figure study' },
					{ src: collage, alt: 'Grid collage' },
				]}
			/>
		</>
	)
}
